import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./rollback.scss";
import { __ } from "@wordpress/i18n";

const RollBack = () => {
  // --- BLOCKS DATA ---
  const blocksData = nxtext_ajax_object?.dashData;
  const blocksVersions = blocksData?.rollbacVer || [];
  const blocksUrl = nxtext_ajax_object?.tpgb_url || "";

  // --- EXTENSION DATA ---
  const extData = nxtext_ajax_object?.dashData;
  const extVersions = extData?.ext_rollbacVer || [];
  const extUrl = nxtext_ajax_object?.nxtex_url || "";

  const [blocksVer, setBlocksVer] = useState(blocksVersions[0] || "");
  const [extVer, setExtVer] = useState(extVersions[0] || "");

  const navigate = useNavigate();

  useEffect(() => {
    if (blocksData?.whiteLabel?.nxt_rollback_tab === "on" || extData?.whiteLabel?.nxt_rollback_tab === "on") {
      navigate("/");
    }
  }, [blocksData?.whiteLabel?.nxt_rollback_tab, extData?.whiteLabel?.nxt_rollback_tab, navigate]);

  const toggleDropdown = (e) => {
    const main = e.target.closest(".nxtext_cstm_dropdown");
    const dropdown = main?.querySelector(".nxtext_cstm_dropdown_content");
    if (dropdown) dropdown.classList.toggle("nxt_wp_show");
  };

  const handleRollback = (type) => {
    const confirmMsg = __("Are you sure you want to reinstall the previous version?", 'nexter-extension');
    if (!window.confirm(confirmMsg)) return;

    if (type === "blocks" && blocksData?.tpgbRollbackUrl) {
      let url = blocksData.tpgbRollbackUrl.replace("TPGB_VERSION", blocksVer).replace(/&amp;/g, "&");
      window.location.href = url;
    }

    if (type === "ext" && extData?.rollbackUrl) {
      let url = extData.rollbackUrl.replace("NEXTER_EXT_VER", extVer).replace(/&amp;/g, "&");
      window.location.href = url;
    }
  };

  const VersionDropdown = ({ label, current, versions, setVersion }) => (
    
      <div className="nxtext_cstm_dropdown" onClick={toggleDropdown}>
        <div className="nxtext_cstm_dropdown_header">
          <label htmlFor={"nxt_rollVersion"+label}>{current}</label>
          <img src={(blocksUrl || extUrl) + "assets/svg/nxt_chevron_down.svg"} draggable={false} alt="" />
        </div>
        <div id={"nxt_rollVersion"+label} className='nxtext_cstm_dropdown_content'>
          {versions.map((v) => (
            <div className="nxt-option" key={v} onClick={() => setVersion(v)}>
              {__(v, 'nexter-extension')}
            </div>
          ))}
        </div>
      </div>
  );

  return (
    <div className="nxt_rollback_cover_main nxtext_main_container">
        <div className="nxtext_section_heading_cover">
            <div className="nxt_warning_text">
            <h3 className="nxtext_primary_heading">{__("Roll Back Plugin", 'nexter-extension')}</h3>
            </div>
        </div>
        
        <div className="nxt_rollback_version_field_cover">
            {/* --- Nexter Blocks Rollback --- */}
            {blocksVersions.length > 0 && (
                <div className='nxt_rollback_content_cover'>
                    <div className="nxtext_field_card">
                        <div className='nxtext_card_top_detail'> 
                            <div className='nxtext_field_card_h_strip'> 
                                <label htmlFor="nxt_lazyload" className='nxtext_secondary_heading'>{ __( 'Roll Back Nexter Blocks FREE Version' , 'nexter-extension' ) }</label>
                            </div>
                            <div className="nxtext_field_dropdown">
                                <VersionDropdown
                                    label="Blocks"
                                    current={blocksVer}
                                    versions={blocksVersions}
                                    setVersion={setBlocksVer}
                                />
                                <button className="nxt_blue_common_btn" onClick={() => handleRollback("blocks")}>
                                    {__("Rollback", 'nexter-extension')}
                                </button>
                            </div>
                        </div>
                    <div className="nxt_warning_text">
                        <img src={(blocksUrl || extUrl) + "assets/svg/nxt_warning.svg"} draggable={false} alt="" />
                        {__("Warning: Please backup your database before making the rollback.", 'nexter-extension')}
                    </div>
                    </div>
                </div>
            )}

            {/* --- Nexter Extension Rollback --- */}
            {extVersions.length > 0 && (
                <div className='nxt_rollback_content_cover'>
                    <div className="nxtext_field_card">
                        <div className="nxtext_card_top_detail">
                            <div className="nxtext_field_card_h_strip">
                                <label htmlFor="nxt_lazyload" className='nxtext_secondary_heading'>
                                    {__("Roll Back Nexter Extension FREE Version", 'nexter-extension')}
                                </label>
                            </div>
                        </div>
                        <div className="nxtext_field_dropdown">
                            <VersionDropdown label="Extension" current={extVer} versions={extVersions} setVersion={setExtVer} />
                            <button className="nxt_blue_common_btn" onClick={() => handleRollback("ext")}>
                            {__("Rollback", 'nexter-extension')}
                            </button>
                        </div>
                        <div className="nxt_warning_text">
                          <img src={(blocksUrl || extUrl) + "assets/svg/nxt_warning.svg"} draggable={false} alt="" />
                          {__("Warning: Please backup your database before making the rollback.", 'nexter-extension')}
                      </div>
                    </div>
                </div>
            )}
        </div>
    </div>
  );
};

export default RollBack;